import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { modifyLinkPropsForMode } from './utils/ProductUtils';

const ViewAllLink = ({ renderMode, shopWidgetSamePage, translate, baseProps }) => {
  const linkProps = modifyLinkPropsForMode(baseProps, renderMode, shopWidgetSamePage);
  const containerStyles = {
    paddingVertical: 'xlarge',
    textAlign: 'center'
  };

  return (
    <UX2.Element.Block style={ containerStyles }>
      <UX2.Element.MoreLink.Forward { ...linkProps } children={ translate('products.view_all') } />
    </UX2.Element.Block>
  );
};

ViewAllLink.propTypes = {
  renderMode: PropTypes.string,
  shopWidgetSamePage: PropTypes.bool,
  translate: PropTypes.func,
  baseProps: PropTypes.object
};

export default ViewAllLink;
